import { render } from "./ItemsPopover.vue?vue&type=template&id=a7821ad4&scoped=true&lang=pug"
import script from "./ItemsPopover.vue?vue&type=script&lang=js"
export * from "./ItemsPopover.vue?vue&type=script&lang=js"

import "./ItemsPopover.vue?vue&type=style&index=0&id=a7821ad4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7821ad4"]])

export default __exports__